import React, { Component } from "react";
import {
  Card,
  Grid,
  Button
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import history from '../../../history';
import { loginWithUsernameAndPassword, loginErrorClear } from "../../redux/actions/LoginActions";
import { loadBrand } from "../../redux/actions/BrandActions";
var pjson = require('../../../../package.json');
const {version} = pjson;

class SignIn extends Component {
  state = {
    username: "",
    password: "",
    brand: { logoUrl: ""}
  };

  componentDidMount() {
    if (!this.props.brand.loaded){
        this.props.loadBrand();
    } else {
      this.setState ({ brand: this.props.brand.data});
      document.title = this.props.brand.data.key;
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.brand.loaded === true && prevProps.brand.loaded === false) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
    {
      this.setState ({ brand: this.props.brand.data});
      document.title = this.props.brand.data.key;
    }
  }

  handleChange = event => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value
    });
    this.props.loginErrorClear();
  };

  handleFormSubmit = event => {
    sessionStorage.resetSessionTimer = "YES";
    this.props.loginWithUsernameAndPassword({ ...this.state });
  };

  forgotUsername = event => {
    history.push(`/session/requestusername`);
  }

  forgotPassword = event => {
    history.push(`/session/requestpasswordreset`);
  }

  render() {
    let { username, password } = this.state;
    let { logoUrl } = this.state.brand;
    return (
      <div className="signup flex flex-center w-100 h-100vh">
        <div className="p-8">
          <Card className="signup-card position-relative y-center">
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-32 flex flex-center flex-middle h-100">
                  <img src={logoUrl} alt="" />
                </div>

              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
              <div className="bg-error text-center text-white">
                {this.props.login.errorMessage}
              </div>

                <div className="p-36 h-100 bg-light-gray">
                  <ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
                    <TextValidator
                      className="mb-24 w-100"
                      variant="outlined"
                      label="Username"
                      onChange={this.handleChange}
                      type="text"
                      name="username"
                      value={username}
                      validators={["required"]}
                      errorMessages={[
                        "this field is required"
                      ]}
                    />
                    <TextValidator
                      className="mb-16 w-100"
                      label="Password"
                      variant="outlined"
                      onChange={this.handleChange}
                      name="password"
                      type="password"
                      value={password}
                      validators={["required"]}
                      errorMessages={["this field is required"]}
                    />
                    {
                        (sessionStorage.userSessionOut === 'true') ?
                        <div className="session-timeout-msg">You have been logged out due to
                          inactivity.</div> : ''
                    }
                    <div className="flex flex-middle">
                      <Button
                        className="capitalize"
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        Sign in
                      </Button>
                    </div>
                    <br/>
                    <div className="flex flex-middle">

                      <Button color="primary" className="capitalize" onClick={() => this.forgotUsername()}>
                        <i><small>forgot username</small></i>
                      </Button>
                      <Button color="primary" className="capitalize" onClick={() => this.forgotPassword()}>
                      <i><small>forgot password</small></i>
                      </Button>

                    </div>

                  </ValidatorForm>
                  <div className="text-center">
                    <small><i>v{version}</i></small>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loginWithUsernameAndPassword: PropTypes.func.isRequired,
  login: state.login,
  brand: state.brand
});
export default withRouter(
  connect(
    mapStateToProps,
    { loginWithUsernameAndPassword, loginErrorClear, loadBrand }
  )(SignIn)
);
